<template>
  <!-- 列印投票單議案選擇彈窗 -->
  <div id="ChooseTopicToPrintDialog_main">
    <el-dialog
      title="列印投票單"
      :visible.sync="dialogVisible"
      width="60%"
      @close="data = {}"
    >
      <div class="printSizeContainer">
        <el-radio
          v-model="printSize"
          label="regular"
        >
          投票單（6張/頁）
        </el-radio>
        <el-radio
          v-model="printSize"
          label="big"
        >
          投票單（2張/頁）
        </el-radio>
      </div>
      <el-table
        ref="chooseTopicTable"
        :data="topicList"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          min-width="60"
        />
        <el-table-column
          label="議案標題"
          prop="title"
        />
      </el-table>
      <div slot="footer">
        <el-button
          round
          @click="dialogVisible = false"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          :disabled="multipleSelection.length == 0"
          round
          @click="submit"
        >
          列印
        </el-button>
      </div>
    </el-dialog>
    <PrintVotingPaper ref="printVotingPaper" />
    <PrintVotingPaperBig ref="printVotingPaperBig" />
  </div>
</template>
<script>
import PrintVotingPaper from './PrintVotingPaper.vue'
import PrintVotingPaperBig from './PrintVotingPaperBig.vue'
export default {
  components: {
    PrintVotingPaper,
    PrintVotingPaperBig
  },
  data () {
    return {
      printSize: 'regular',
      dialogVisible: false,
      topicList: [],
      assemblyTitle: '',
      assemblyId: '',
      multipleSelection: []
    }
  },
  methods: {
    openDialog (topicList, assemblyTitle, assemblyId) {
      console.log('開啟列印投票單議案選擇彈窗', topicList)
      this.dialogVisible = true
      this.topicList = topicList
      this.assemblyTitle = assemblyTitle
      this.assemblyId = assemblyId
    },
    submit () {
      if (this.printSize === 'regular') {
        this.$refs.printVotingPaper.print(this.assemblyId, this.assemblyTitle, this.multipleSelection)
      } else {
        this.$refs.printVotingPaperBig.print(this.assemblyId, this.assemblyTitle, this.multipleSelection)
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    }
  }
}
</script>
<style lang="sass" scoped>
#ChooseTopicToPrintDialog_main
  display: inline-block
  margin: 0 10px
  ::v-deep .el-dialog
    +basicDialog
    min-width: 540px
    .printSizeContainer
      padding-bottom: 20px
    ::v-deep .el-table
      +basicTable
    .el-dialog__footer
      border-top: 0
      text-align: center
      padding-top: 0
</style>
